import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { creditNoteSchema } from './schemas';

export type Payload = {
  fcEntryNumber: string;
  invoiceId: number;
  nextNumber: number;
  numberingSeriesId: number;
  reason: string;
};

export const useCreateCreditNote = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: Payload) => {
      const { data: creditNote } = await fetchJson('/credit-notes', {
        method: 'POST',
        schema: apiResourceSchema(creditNoteSchema),
        body,
      });

      return creditNote;
    },
    onSuccess: (creditNote) => {
      queryClient.invalidateQueries({ queryKey: QueryKeys.creditNotes.index.root });
      queryClient.invalidateQueries({ queryKey: QueryKeys.invoices.index.root });
      queryClient.invalidateQueries({ queryKey: QueryKeys.invoices.creditable });
      queryClient.invalidateQueries({ queryKey: QueryKeys.statistics.root });
      queryClient.invalidateQueries({ queryKey: QueryKeys.user }); // Refetch numbering series to update the next number

      return queryClient.invalidateQueries({ queryKey: QueryKeys.invoices.show.id(creditNote.invoiceId) });
    },
  });
};
